// Option lists for the onboarding wizard. Keeps the form code lean and lets
// HR refine these without touching component logic.

export const STAATSANGEHOERIGKEIT_OPTIONS = [
  // Häufigste DE-Mittelstand Werte zuerst, danach alphabetisch.
  { value: 'Deutschland',        label: 'Deutschland' },
  { value: 'Türkei',             label: 'Türkei' },
  { value: 'Polen',              label: 'Polen' },
  { value: 'Rumänien',           label: 'Rumänien' },
  { value: 'Italien',            label: 'Italien' },
  { value: 'Bulgarien',          label: 'Bulgarien' },
  { value: 'Kroatien',           label: 'Kroatien' },
  { value: 'Russland',           label: 'Russland' },
  { value: 'Ukraine',            label: 'Ukraine' },
  { value: 'Syrien',             label: 'Syrien' },
  { value: 'Iran',               label: 'Iran' },
  { value: 'Afghanistan',        label: 'Afghanistan' },
  // EU/EWR
  { value: 'Belgien',            label: 'Belgien' },
  { value: 'Dänemark',           label: 'Dänemark' },
  { value: 'Estland',            label: 'Estland' },
  { value: 'Finnland',           label: 'Finnland' },
  { value: 'Frankreich',         label: 'Frankreich' },
  { value: 'Griechenland',       label: 'Griechenland' },
  { value: 'Irland',             label: 'Irland' },
  { value: 'Island',             label: 'Island' },
  { value: 'Lettland',           label: 'Lettland' },
  { value: 'Liechtenstein',      label: 'Liechtenstein' },
  { value: 'Litauen',            label: 'Litauen' },
  { value: 'Luxemburg',          label: 'Luxemburg' },
  { value: 'Malta',              label: 'Malta' },
  { value: 'Niederlande',        label: 'Niederlande' },
  { value: 'Norwegen',           label: 'Norwegen' },
  { value: 'Österreich',         label: 'Österreich' },
  { value: 'Portugal',           label: 'Portugal' },
  { value: 'Schweden',           label: 'Schweden' },
  { value: 'Schweiz',            label: 'Schweiz' },
  { value: 'Slowakei',           label: 'Slowakei' },
  { value: 'Slowenien',          label: 'Slowenien' },
  { value: 'Spanien',            label: 'Spanien' },
  { value: 'Tschechien',         label: 'Tschechien' },
  { value: 'Ungarn',             label: 'Ungarn' },
  { value: 'Zypern',             label: 'Zypern' },
  // Sonstiges (häufige Drittstaaten)
  { value: 'Albanien',           label: 'Albanien' },
  { value: 'Bosnien-Herzegowina', label: 'Bosnien-Herzegowina' },
  { value: 'Brasilien',          label: 'Brasilien' },
  { value: 'China',              label: 'China' },
  { value: 'Indien',             label: 'Indien' },
  { value: 'Kosovo',             label: 'Kosovo' },
  { value: 'Marokko',            label: 'Marokko' },
  { value: 'Nigeria',            label: 'Nigeria' },
  { value: 'Nordmazedonien',     label: 'Nordmazedonien' },
  { value: 'Pakistan',           label: 'Pakistan' },
  { value: 'Serbien',            label: 'Serbien' },
  { value: 'Tunesien',           label: 'Tunesien' },
  { value: 'USA',                label: 'USA' },
  { value: 'Vereinigtes Königreich', label: 'Vereinigtes Königreich' },
  { value: 'Vietnam',            label: 'Vietnam' },
  { value: 'Sonstiges',          label: 'Sonstiges …' },
] as const

export const FAMILIENSTAND_OPTIONS = [
  { value: 'ledig',                            label: 'ledig' },
  { value: 'verheiratet',                      label: 'verheiratet' },
  { value: 'geschieden',                       label: 'geschieden' },
  { value: 'verwitwet',                        label: 'verwitwet' },
  { value: 'eingetragene Lebenspartnerschaft', label: 'eingetragene Lebenspartnerschaft' },
  { value: 'getrennt lebend',                  label: 'getrennt lebend' },
] as const

export const RELIGION_OPTIONS = [
  { value: 'evangelisch',     label: 'evangelisch (ev)' },
  { value: 'römisch-katholisch', label: 'römisch-katholisch (rk)' },
  { value: 'altkatholisch',   label: 'altkatholisch' },
  { value: 'jüdisch',         label: 'jüdisch' },
  { value: 'islamisch',       label: 'islamisch' },
  { value: 'orthodox',        label: 'orthodox' },
  { value: 'konfessionslos',  label: 'konfessionslos / keine' },
  { value: 'sonstige',        label: 'sonstige' },
] as const

export const BUNDESLAND_OPTIONS = [
  'Hamburg', 'Schleswig-Holstein', 'Niedersachsen', 'Bremen',
  'Mecklenburg-Vorpommern', 'Berlin', 'Brandenburg', 'Sachsen-Anhalt',
  'Sachsen', 'Thüringen', 'Hessen', 'Nordrhein-Westfalen',
  'Rheinland-Pfalz', 'Saarland', 'Bayern', 'Baden-Württemberg',
] as const

export const STEUERKLASSE_OPTIONS = [
  { value: '1', label: '1 — ledig / nicht verheiratet' },
  { value: '2', label: '2 — alleinerziehend' },
  { value: '3', label: '3 — verheiratet, höheres Einkommen' },
  { value: '4', label: '4 — verheiratet, beide gleich' },
  { value: '5', label: '5 — verheiratet, niedrigeres Einkommen' },
  { value: '6', label: '6 — Zweit-/Nebenjob' },
] as const

// Major German Krankenkassen (kann später aus DB-Tabelle gespeist werden).
export const KRANKENKASSE_OPTIONS = [
  'AOK Nordost',
  'AOK Rheinland/Hamburg',
  'AOK Bayern',
  'AOK Niedersachsen',
  'Techniker Krankenkasse (TK)',
  'BARMER',
  'DAK-Gesundheit',
  'IKK classic',
  'KKH',
  'hkk Krankenkasse',
  'Knappschaft',
  'BKK Mobil Oil',
  'BKK VBU',
  'BKK ProVita',
  'BKK Linde',
  'BKK firmus',
  'HEK',
  'HKK',
  'mhplus BKK',
  'pronova BKK',
  'SBK',
  'Viactiv',
  'Sonstige …',
] as const

export const FUEHRERSCHEIN_KLASSEN = [
  { value: 'B',   label: 'B — PKW bis 3,5 t' },
  { value: 'BE',  label: 'BE — PKW + Anhänger' },
  { value: 'B96', label: 'B96 — PKW + leichter Anhänger' },
  { value: 'C1',  label: 'C1 — LKW 3,5–7,5 t' },
  { value: 'C1E', label: 'C1E — C1 + Anhänger' },
  { value: 'C',   label: 'C — LKW > 7,5 t' },
  { value: 'CE',  label: 'CE — LKW + Anhänger' },
  { value: 'D1',  label: 'D1 — Bus bis 16 Sitze' },
  { value: 'D',   label: 'D — Bus' },
  { value: 'A1',  label: 'A1 — Motorrad bis 125ccm' },
  { value: 'A2',  label: 'A2 — Motorrad bis 35kW' },
  { value: 'A',   label: 'A — Motorrad' },
  { value: 'L',   label: 'L — Land-/Forst-Maschine' },
  { value: 'T',   label: 'T — Zugmaschine' },
] as const

export const GESCHLECHT_OPTIONS = [
  { value: 'männlich', label: 'männlich' },
  { value: 'weiblich', label: 'weiblich' },
  { value: 'divers',   label: 'divers' },
] as const

export const JA_NEIN_OPTIONS = [
  { value: 'Ja',   label: 'Ja' },
  { value: 'Nein', label: 'Nein' },
] as const

// ── Validators ──────────────────────────────────────────────────────────

/** German IBAN: DE + 2 check digits + 18 digits = 22 chars. Lenient (allows spaces). */
export function isValidIban(value: string): boolean {
  const cleaned = value.replace(/\s+/g, '').toUpperCase()
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(cleaned)) return false
  // ISO 13616 mod-97 check
  const rearranged = cleaned.slice(4) + cleaned.slice(0, 4)
  const numeric = rearranged.replace(/[A-Z]/g, ch => String(ch.charCodeAt(0) - 55))
  // BigInt mod
  let remainder = 0
  for (const d of numeric) {
    remainder = (remainder * 10 + Number(d)) % 97
  }
  return remainder === 1
}

/** Format IBAN in 4-char groups for display. */
export function formatIban(value: string): string {
  return value.replace(/\s+/g, '').replace(/(.{4})/g, '$1 ').trim()
}

/** German Steuer-ID: exactly 11 digits, with checksum (relaxed: digit count only here). */
export function isValidSteuerId(value: string): boolean {
  const cleaned = value.replace(/\s+/g, '')
  return /^\d{11}$/.test(cleaned)
}

/** German Sozialversicherungsnummer: 12 chars (2 digits + 6 digits + 1 letter + 2 digits + 1 digit). */
export function isValidSvNummer(value: string): boolean {
  const cleaned = value.replace(/\s+/g, '').toUpperCase()
  return /^\d{2}\d{6}[A-Z]\d{3}$/.test(cleaned)
}

/** German PLZ: exactly 5 digits. */
export function isValidPlz(value: string): boolean {
  return /^\d{5}$/.test(value.trim())
}

/** Lenient phone validator: only digits + spaces + + - / are allowed; min 6 digits. */
export function isValidPhone(value: string): boolean {
  if (!value) return true // empty handled by required check elsewhere
  const digits = value.replace(/\D/g, '')
  return digits.length >= 6 && /^[+\d\s\-/()]+$/.test(value)
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}
